import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';
import { Typography } from '@mui/material';

interface IPaymentNotificationContent {
	contactNumber: string;
}

/**
 * - Simple component to display a notification when a policy is blocked by a payment
 */
const PaymentNotificationContent = ({ contactNumber }: IPaymentNotificationContent) => {
	return (
		<Typography>
			A payment on your policy is currently being processed. Please call us
			{contactNumber ? (
				<>
					{' '}
					on <MobileOnlyLink href={`tel:${contactNumber}`} text={contactNumber} />
				</>
			) : null}{' '}
			and we&apos;ll help you with your cancellation request.
		</Typography>
	);
};

export default PaymentNotificationContent;
